<template lang="pug">

  transition-group(name="cross-fade")
    img(src="@/assets/img/man/1-question.svg", alt="" v-if="isFirst" key="first")
    img(src="@/assets/img/man/2-question.svg", alt="" v-if="painStatus === 0 && !isFirst" key="pain0")
    img(src="@/assets/img/man/pain1.svg", alt="" v-if="painStatus === 1" key="pain1")
    img(src="@/assets/img/man/pain2.svg", alt="" v-if="painStatus === 2" key="pain2")
    img(src="@/assets/img/man/pain3.svg", alt="" v-if="painStatus === 3" key="pain3")
    img(src="@/assets/img/man/pain4.svg", alt="" v-if="painStatus === 4" key="pain4")

</template>

<script>
  import { forEach } from '../plugins/polyfill';
  export default {
    name: 'ManImage',
    props: {
      isFirst: {
        type: Boolean,
        required: false,
      },
      painLevel: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        images: [
          require('@/assets/img/man/1-question.svg'),
          require('@/assets/img/man/2-question.svg'),
          require('@/assets/img/man/pain1.svg'),
          require('@/assets/img/man/pain2.svg'),
          require('@/assets/img/man/pain3.svg'),
          require('@/assets/img/man/pain4.svg'),
        ]
      };
    },
    created () {
      forEach(this.images, (item) => {
        this.imagesPreload(item);
      });
    },
    computed: {
      painStatus () {

        let status = 0;

        if (this.painLevel > 10 && this.painLevel <= 25) {
          status = 1;
        }

        if (this.painLevel > 25 && this.painLevel <= 50) {
          status = 2;
        }

        if (this.painLevel > 50 && this.painLevel <= 75) {
          status = 3;
        }

        if (this.painLevel > 75) {
          status = 4;
        }

        return status;
      },
    },
    methods: {
      imagesPreload (src) {
        let img = new Image(1, 1);
        img.src = src;
      },
    },
  };
</script>

<style scoped>

</style>
